import { EnrollmentType } from '../../../../state/enrollment/enrollmentModel';
import styles from './EnrollmentSelector.module.scss';
import classNames from 'classnames/bind';
import CardButton from '../../../../components/CardButton';
import { setEnrollmentType } from '../../../../state/enrollment/enrollmentActions';

const cx = classNames.bind(styles);

interface EnrollmentSelectorProps {
  enrollmentType: EnrollmentType;
  setEnrollmentType: typeof setEnrollmentType;
}

const EnrollmentSelector = (props: EnrollmentSelectorProps) => {
  const onSingleEntityClick = () => props.setEnrollmentType(EnrollmentType.SINGLE_ENTITY);
  const onMultipleEntityClick = () => props.setEnrollmentType(EnrollmentType.MULTIPLE_ENTITY);

  const isSingleEntity: boolean = props.enrollmentType === EnrollmentType.SINGLE_ENTITY;
  const isMultipleEntity: boolean = props.enrollmentType === EnrollmentType.MULTIPLE_ENTITY;

  return (
    <div className={cx('enrollment-selector')}>
      <CardButton
        className={cx('enrollment-selector__option', {
          'enrollment-selector__option--active': isSingleEntity,
        })}
        onClick={onSingleEntityClick}
        isActive={isSingleEntity}
      >
        Enroll a single entity
      </CardButton>
      <CardButton
        className={cx('enrollment-selector__option', {
          'enrollment-selector__option--active': isMultipleEntity,
        })}
        onClick={onMultipleEntityClick}
        isActive={isMultipleEntity}
      >
        Enroll multiple entities
      </CardButton>
    </div>
  );
};

export default EnrollmentSelector;
